export const SORTING_ORDER = {
    AZ: 'AZ',
    ZA: 'ZA'
} as const;

export const SORT_OPTIONS = [
    {
        sortKey: SORTING_ORDER.AZ,
        text: 'A-Z'
    },
    {
        sortKey: SORTING_ORDER.ZA,
        text: 'Z-A'
    }
] as const;

export type SortingType = typeof SORTING_ORDER.AZ | typeof SORTING_ORDER.ZA;

export const NEW_CATEGORY_UIDS = ['casino-new', 'xsell-new'];

export const LIVESTREAM_CATEGORY_UID = 'casino-livestream';
